import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 20v-16","key":"svg-0"}],["path",{"d":"M17 4v16","key":"svg-1"}],["path",{"d":"M20 4h-16","key":"svg-2"}]]

const IconMathPi = createReactComponent('outline', 'math-pi', 'MathPi', __iconNode);

export default IconMathPi;